import axios from '@/utils/request'
var Qs = require('qs')

export default {
  types_all: ["inventory", "purchase", "manufacture", "returnBack",],
  types_phase: ['mesQuality', 'core'],
  // 2020-11-23
  search(params) {
    return axios.get('/reworks?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // 2020-12-28
  searchMes(params) {
    return axios.get('/mes/reworks?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // countToSupplier(params) {
  //   return axios.get('/reworks/count-to-supplier');
  // },
  // stateCount(params) {
  //   return axios.get('/reworks/state-count');
  // },
  // // 2020-09-08
  // create(params) {
  //   return axios.post('/reworks', params)
  // },
  //2020-11-18
  inventoryRework(params) {
    return axios.put('/reworks/inventory-rework', params)
  },

  // 2020-09-08
  insertBatch(params) {
    return axios.post('/mes/reworks/insert-batch', params);
  },
  // 2020-10-16
  findByEntityId(id, params) {
    return axios.get('/reworks/find-by-entity-id/' + id, params);
  },
  // 2020-12-19
  unFinishCount() {
    return axios.get('/reworks/un-finish-count');
  },
  // 2021-04-25
  unFinishPurchaseCount() {
    return axios.get('/reworks/un-finish-purchase-count');
  },
  // 2020-12-19
  customerReworkCount() {
    return axios.get('/reworks/customer-rework-count');
  },
  // 2020-12-23
  findByWorkerOrderId(workOrderId) {
    return axios.get('/mes/reworks/find-by-work-order-id/' + workOrderId);
  },
  // 2020-12-23
  finish(id, params) {
    return axios.put('/mes/reworks/' + id + '/finish', params);
  },
  // 2021-06-05
  markFinish(id) {
    return axios.put('/reworks/' + id + '/mark-finish');
  },
  // 2020-12-28
  countToFactory() {
    return axios.get('/reworks/count-to-factory');
  },
  // 2020-12-28
  phaseReworkCount() {
    return axios.get('/mes/reworks/record');
  },
  // 2022-03-10
  exportExcel(params) {
    return axios.get('/reworks/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
  },
  // // 2021-05-25
  // supplierReworkFinish(id) {
  //   return axios.put('/reworks/' + id + '/supplier-rework-finish');
  // },
  // // 2021-05-27
  // customerReworkFinish(id) {
  //   return axios.put('/reworks/' + id + '/customer-rework-finish');
  // },
}

